import { render } from "./IconFileDocument.vue?vue&type=template&id=e7c2b434"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconFileDocument.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e7c2b434"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e7c2b434', __exports__)) {
    api.reload('e7c2b434', __exports__)
  }
  
  module.hot.accept("./IconFileDocument.vue?vue&type=template&id=e7c2b434", () => {
    api.rerender('e7c2b434', render)
  })

}


export default __exports__